"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
// assigned-repayment-tape.d.ts
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    loanProductSlug: zod_1.z.string().describe('Loan product slug'),
    creditFacilitySlug: zod_1.z.string().describe('Credit facility slug'),
});
exports.nodeType = 'file_assignedRepaymentTape';
exports.IntermediateRecordConfigSchema = zod_1.z.object({});
exports.artifactType = 'assignedRepaymentTape';
//# sourceMappingURL=types.js.map